import { extend } from 'sk-ui/lib/utils/util.js'

export default {
  productStrategyOkActionCb({ commit }, params) {
    if (params?.response?.data?.status == 'SUCCESS') {
      this.dispatch('OpenNotification', { message: '策略配置成功', type: 'success' })
    }
  },
  strategyRelationProduct({ commit }, props) {
    import('../productMng/metaData/product').then(metaData => {
      const metaDataCopy = extend(true, {}, metaData)
      metaDataCopy.default.view.columns.unshift({
        props: {
          type: 'selection',
          width: 55
        }
      })
      metaDataCopy.default.view.menus = []
      this.dispatch('OpenRelationDialog', { metaData: metaDataCopy, props })
    })
  }
}
